module.exports = __webpack_public_path__ + "img/img31.dd7a7646.png";